import './App.css';
import NavBar from './components/nav/NavBar';
import { Routes, Route, BrowserRouter as Router, HashRouter} from 'react-router-dom';
import SideBar from './components/sidebar/SideBar';
import HomePage from './pages/Homepage';
import { Simulator } from './pages/Simulator';
import Form from './components/form/Form';
import { Suspense, lazy } from 'react';
import Loading from './components/Loading';
import { Another } from './pages/Another';
import HelpPage from './pages/HelpPage';
import PageNotFound from './pages/PageNotFound';
import Results from './pages/Results';
import { PDFViewer } from '@react-pdf/renderer';
import ResultsDoc from './ResultsDoc';
import ScrollToTop from '../src/components/ScrollTop'
import AboutPage from './pages/AboutPage';

const LazyResults = lazy(() => import("./pages/AboutPage"));


function App() {
  return (
    <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/product" element={<Simulator />} />
      <Route path="/simulator" element={<Simulator />} />
      <Route path="/simulator/results" element={<Results />} />
      <Route path="/help" element={<HelpPage />} />
      <Route path='/about' element={<AboutPage />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
    </>
  );
}

export default App;
